import AutoSave from './AutoSave'
import AutoSaveSync from './AutoSaveSync'

export default Object.assign(AutoSave, {
  Sync: AutoSaveSync,
})
